<template>
  <div>
    <UpdateTitleOrgchart titlename="จัดการฝ่ายงาน" :btnDel="true" />
    <UpdateOrgchart
      :loading="loading"
      :orgchartId="this.$route.params.id"
      :companyItems="itemCompanyName"
      companyItemsText="companyFullNameEng"
      companyItemsValue="_id"
      :companySelect="companyId"
      :titleItems="itemCompanyTitle"
      :titleSelect="selectCompanyTitle"
      :headerItems="itemCompanyHeader"
      headerItemsText="orgChartName"
      headerItemsValue="_id"
      :headerSelect="selectCompanyHeader"
      :headerSelectDisable="disableSelectCompanyHeader"
      :orgchartLevel="orgchartLevel"
      :orgchartName="orgchartName"
      :showInvisSave="showInvisSave"
      :haveLead="haveLead"
      :orgchartLoadingUser="isLoading"
      :orgchartUserItem="itemUser"
      orgchartUserText="employeeId"
      orgchartUserValue="id"
      :orgchartUserId="orgchartUserId"
      :orgchartTemporaryLeader="temporaryLeader"
      :orgchartUserName="orgchartUserName"
      :orgchartUserPosition="orgchartUserPosition"
    />
  </div>
</template>

<script>
import { UpdateTitleOrgchart, UpdateOrgchart } from '@/components/index'
import {
  getSelectCompany,
  getSelectCompanyHeader,
  getOrgChartById,
  getUserByKeyword,
  updateOrgChartByNode,
  deleteOrgChartById
} from '@/API/API'
import swal from 'sweetalert'
import { EventBus } from '@/EventBus'

export default {
  name: 'update-lineofwork',
  components: {
    UpdateTitleOrgchart,
    UpdateOrgchart
  },
  data () {
    return {
      tokenUser: '',
      propsid: '',
      propsitems: {},
      itemCompanyName: [],
      itemCompanyTitle: ['สายงาน', 'ฝ่ายงาน'],
      itemCompanyHeader: [],
      itemUser: [],
      selectCompanyName: '',
      selectCompanyTitle: 'ฝ่ายงาน',
      selectCompanyHeader: null,
      orgchartLevel: '',
      orgchartTemporaryLeader: false,
      orgchartName: '',
      orgchartUserId: '',
      orgchartUserName: '',
      orgchartUserPosition: '',
      searchUser: null,
      disableSelectCompanyHeader: false,
      loading: true,
      itemNode: [],
      userItems: {},
      isLoading: false,
      showInvisSave: false,
      canSave: false,
      companyId: '',
      subjectName: '',
      haveLead: false,
      userId: '',
      temporaryLeader: false,
      userName: '',
      userPosition: ''
    }
  },
  mounted () {
    EventBus.$on('updateOrgchart-companySelect', this.getSelectCompany)
    EventBus.$on('updateOrgchart-changeHaveLeader', this.addLeader)
    EventBus.$on('updateOrgchart-changeLeader', this.changeLeaderData)
    EventBus.$on('updateOrgchart-cancelUpdate', this.cancelAddOrgChart)
    EventBus.$on('updateOrgchart-saveUpdate', this.checkItemToSave)
    EventBus.$on('updateOrgchart-confirmDelete', this.confirmDelete)
  },
  created () {
    this.tokenUser = this.$store.state.token
    if (this.tokenUser) {
      if (!this.$route.params.id) this.$router.go(-1)
      if (this.$route.params.id) {
        this.propsid = this.$route.params.id
        this.propsitems = this.$route.params.item
        this.companyId = this.$route.params.item.companyId
        this.selectCompanyName = this.$route.params.item.companyShortName
        var orgchartnames = this.$route.params.item.orgChartName.split(' ')
        var orgchart2 = this.$route.params.item.orgChartName.replace(`${orgchartnames[0]} `, '')
        this.selectCompanyTitle = orgchartnames[0] || null
        this.selectCompanyHeader = this.$route.params.item.orgChartPid
        this.orgchartLevel = this.$route.params.item.orgChartLevel
        // if (this.$route.params.item.orgChartLevel.length === 1) {
        //   this.disableSelectCompanyHeader = true
        // }
        this.orgchartName = orgchart2 || this.$route.params.item.orgChartName
        if (this.$route.params.item.userName) this.haveLead = true
        this.orgchartUserId = this.$route.params.item.orgChartUsers
        // console.log(this.$route.params.item)
        this.temporaryLeader = this.$route.params.item.temporaryLeader
        this.orgchartUserName = this.$route.params.item.userName
        this.orgchartUserPosition = this.$route.params.item.userPosition
        this.initGetOrgChartById()
        this.initItemCompanyName()
        this.getUser()
        EventBus.$emit('updateOrgchart-changeCompanySelect', this.companyId)
      }
    }
  },
  watch: {
    selectCompanyName () {
      if (this.selectCompanyName && this.selectCompanyTitle) {
        this.initItemCompanyHeader()
      }
    },
    selectCompanyTitle () {
      if (this.selectCompanyName && this.selectCompanyTitle) {
        this.initItemCompanyHeader()
      }
    },
    orgchartName () {
      if (this.orgchartName) {
        if (this.haveLead) {
          if (this.orgchartUserId && this.orgchartUserName && this.orgchartUserPosition) {
            this.showInvisSave = true
          } else {
            this.showInvisSave = false
          }
        } else {
          this.showInvisSave = true
        }
      } else this.showInvisSave = false
    }
  },
  methods: {
    async initGetOrgChartById () {
      this.loading = true
      const obj = {
        orgChartId: this.propsid
      }
      try {
        const res = await getOrgChartById(obj, this.tokenUser)
        if (res.success) {
          this.selectCompanyName = res.result.companyId
          this.selectCompanyName = res.result.companyId
          this.selectCompanyTitle = 'ฝ่ายงาน'
          this.selectCompanyHeader = res.result.orgChartPid
          this.searchUser = res.result.orgChartUsers.leaderId
          if (res.result.orgChartUsers.leaderId) {
            this.haveLead = true
            this.orgchartTemporaryLeader = res.result.orgChartUsers.temporaryLeader
          }
          this.userItems = res.result
          // this.itemNode = res.result
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async initItemCompanyName () {
      this.loading = true
      var temp = []
      try {
        const res = await getSelectCompany(this.tokenUser)
        // console.log(res)
        if (res.success) {
          temp = res.result
          this.itemCompanyName = temp
          EventBus.$emit('updateOrgchart-itemCompanySelect', temp)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async initItemCompanyHeader () {
      this.loading = true
      var temp = []
      const obj = {
        companyId: this.selectCompanyName,
        orgChartType: this.selectCompanyTitle
      }

      try {
        const res = await getSelectCompanyHeader(obj, this.tokenUser)
        // console.log(res)
        if (res.success) {
          temp = res.result
          temp.push({
            _id: null,
            orgChartName: 'ไม่มี'
          })
          this.itemCompanyHeader = temp
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getUser () {
      this.loading = true
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          temp = res.result
          this.itemUser = temp
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    addLeader (data) {
      if (!data.orgchartName || data.orgchartName === ' ' || data.orgchartName === '-') {
        swal('คำเตือน', 'กรุณากรอกชื่อหัวข้อ', 'warning', {
          button: false,
          timer: 2000
        })
      }
      if (!data.haveLead) {
        if (this.$route.params.item.userName) {
          this.orgchartUserId = this.$route.params.item.managementUser
          this.orgchartUserName = this.$route.params.item.userName
          this.orgchartUserPosition = this.$route.params.item.userPosition
        } else {
          this.orgchartUserId = ''
          this.orgchartUserName = ''
          this.orgchartUserPosition = ''
        }
      }
    },
    async changeLeaderData (leaderId) {
      this.isLoading = true
      try {
        this.itemUser.map(el => {
          if (el.id === leaderId) {
            this.orgchartUserId = el.id
            this.orgchartUserName = el.name
            this.orgchartUserPosition = el?.position?.positionName || '-'
            const obj = {
              id: el.id,
              name: el.name,
              position: el?.position?.positionName || '-'
            }
            EventBus.$emit('updateOrgchart-changeLeaderUser', obj)
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    checkItemToSave (data) {
      if (data.orgchartName) {
        if (data.haveLead) {
          if (data.orgchartUserId && data.orgchartUserName && data.orgchartUserPosition) {
            this.canSave = true
          } else {
            this.canSave = false
          }
        } else {
          this.canSave = true
        }
      } else this.canSave = false

      if (this.canSave) {
        swal('ต้องการแก้ไขฝ่ายงาน', {
          buttons: {
            cancel: 'ยกเลิก',
            catch: {
              text: 'แก้ไข',
              value: 'save'
            }
          }
        })
          .then((value) => {
            switch (value) {
              case 'save':
                this.saveOrgNode(data)
                break
              default:
                swal('คำเตือน', 'ฝ่ายงานยังไม่ถูกแก้ไข', 'warning', {
                  button: false,
                  timer: 2000
                })
            }
          })
      } else {
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'warning', {
          button: false,
          timer: 2000
        })
      }
    },
    async saveOrgNode (data) {
      this.loading = true
      var temp = []
      temp.push({
        _id: this.$route.params.item._id,
        orgChartType: 'ฝ่ายงาน',
        orgChartPid: data.headerId,
        orgChartName: data.orgchartName,
        orgChartLeader: data.orgchartUserId,
        temporaryLeader: data.orgchartTemporaryLeader
      })

      const obj = {
        companyId: data.companyId,
        nodeEdit: temp
      }

      try {
        const res = await updateOrgChartByNode(obj, this.tokenUser)
        if (res.success) {
          swal('สำเร็จ', 'แก้ไขฝ่ายงานสำเร็จ', 'success', {
            button: false,
            timer: 2000
          }).then(() => this.$router.go(-1))
        } else {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.loading = false
      }
    },
    cancelAddOrgChart () {
      swal('ต้องการยกเลิกการแก้ไขฝ่ายงาน', {
        buttons: [
          'ปิด',
          'ยกเลิก'
        ],
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            swal('คำเตือน', 'ฝ่ายงานยังไม่ถูกแก้ไข', 'warning', {
              button: false,
              timer: 2000
            }).then(() => this.$router.go(-1))
          }
        })
    },
    confirmDelete () {
      swal('ยืนยันลบฝ่ายงานใช่หรือไม่', {
        buttons: [
          'ยกเลิก',
          'ยืนยัน'
        ],
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.deleteOrgchart()
          }
        })
    },
    async deleteOrgchart () {
      const obj = {
        orgChartId: this.propsid
      }
      try {
        const res = await deleteOrgChartById(this.tokenUser, obj)
        // console.log(res)
        if (res.success) {
          swal('สำเร็จ', 'ฝ่ายงานถูกลบแล้ว', 'success', {
            button: false,
            timer: 2000
          }).then(() => this.$router.go(-1))
        } else if (res.pNode) {
          swal('คำเตือน', 'ไม่สามารถลบฝ่ายงานนี้ได้ เนื่องจากมีฝ่ายงานย่อย', 'warning')
        } else {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
